module.exports = __webpack_public_path__ + "static/img/dkwps1.2b40a6c.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/dkwps1.png
// module id = 662
// module chunks = 0